import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { captureApplePayPayment, validateMerchant } from './actions'
import { ApplePayError, ApplePayStatus, PaymentSourceCaptureCardTypes } from '../../model'
import { PURGE } from 'redux-persist'
import { closeCheckout } from '../actions'

export interface ApplePayState {
  status: ApplePayStatus
  error?: ApplePayError
  isEnabledForDevice: boolean
  cardType?: PaymentSourceCaptureCardTypes
  isEnabledForMPANFlow: boolean
}

export const applePayInitialState: ApplePayState = {
  status: ApplePayStatus.Initial,
  isEnabledForDevice: false,
  isEnabledForMPANFlow: false,
}

const applePaySlice = createSlice({
  name: 'applepay',
  initialState: applePayInitialState,
  reducers: {
    setApplePayStatus(state: ApplePayState, action: PayloadAction<ApplePayStatus>) {
      state.status = action.payload
    },
    setApplePayFailure(state: ApplePayState, action: PayloadAction<ApplePayError>) {
      state.status = ApplePayStatus.Error
      state.error = action.payload
    },
    resetApplePayError(state: ApplePayState) {
      state.status = ApplePayStatus.Initial
      state.error = undefined
    },
    setIsEnabledForDevice(state: ApplePayState, action: PayloadAction<boolean>) {
      state.isEnabledForDevice = action.payload
    },
    setIsEnabledForMPANFlow(state: ApplePayState, action: PayloadAction<boolean>) {
      state.isEnabledForMPANFlow = action.payload
    },
    setApplePayCardType(state: ApplePayState, action: PayloadAction<PaymentSourceCaptureCardTypes>) {
      state.cardType = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(captureApplePayPayment.rejected, (state, action) => {
        state.error = ApplePayError.PaymentRejected
      })
      .addCase(validateMerchant.rejected, (state, action) => {
        state.error = ApplePayError.MerchantValidationFailed
      })
      .addCase(closeCheckout, () => applePayInitialState)
      .addCase(PURGE, () => applePayInitialState)
  },
})

export const { resetApplePayError, setApplePayStatus, setApplePayFailure, setIsEnabledForDevice, setApplePayCardType, setIsEnabledForMPANFlow } =
  applePaySlice.actions
export default applePaySlice.reducer
